import awsExports from "./aws-exports";

// get oauth redirects working for local and deployed environments
var urlsIn = awsExports.oauth.redirectSignIn.split(",");
var urlsOut = awsExports.oauth.redirectSignOut.split(",");
const oauth = {
  domain: awsExports.oauth.domain,
  scope: awsExports.oauth.scope,
  redirectSignIn: awsExports.oauth.redirectSignIn,
  redirectSignOut: awsExports.oauth.redirectSignOut,
  responseType: awsExports.oauth.responseType,
};
var hasHostname = (hostname: any) => Boolean(hostname.includes(window.location.hostname));

const hasLocalhost = (hostname: any) => Boolean(
  hostname.match(/localhost/) ||
  hostname.match(/127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/)
);
const isLocalhost = hasLocalhost(window.location.hostname);

if (isLocalhost) {
  urlsIn.forEach((e) => {
    if (hasLocalhost(e)) {
      oauth.redirectSignIn = e;
    }
  });
  urlsOut.forEach((e) => {
    if (hasLocalhost(e)) {
      oauth.redirectSignOut = e;
    }
  });
} else {
  urlsIn.forEach((e) => {
    if (hasHostname(e)) {
      oauth.redirectSignIn = e;
    }
  });
  urlsOut.forEach((e) => {
    if (hasHostname(e)) {
      oauth.redirectSignOut = e;
    }
  });
}

oauth.domain = "auth.llmasaservice.io";

export var configUpdate = awsExports;
configUpdate.oauth = oauth;
